<template>
  <div>
    <el-row class="addCourse-container"> 
        <el-col :span="18" class="border-right cs-left-container">
            <el-row>
                <el-button type="text" icon="el-icon-arrow-left" @click="back">返回</el-button>
            </el-row>
            <el-row>&nbsp;</el-row>
            <el-row>
                <el-col>
                    <span class="cs-title">添加课程时间至</span>
                    <el-row>
                        <el-col :span="3">
                            <strong><label class="el-form-item__label float-right">课程名称：</label></strong>
                        </el-col>
                        <el-col :span="10">
                            <label class="el-form-item__label float-left">{{getCourseName(form)}}</label>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="3">
                            <strong><label class="el-form-item__label float-right">人数：</label></strong>
                        </el-col>
                        <el-col :span="10">
                            <label class="el-form-item__label float-left">{{form.studentCount}}({{form.percentageText}})</label>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="3">
                            <strong><label class="el-form-item__label float-right">速成老师：</label></strong>
                        </el-col>
                        <el-col :span="10">
                          <label v-for="teacher in teacherList" :key="teacher.Id" :class="{'el-form-item__label float-left':true,'cs-list-item':true,'isClicked':checkTeacherIsClicked(teacher.Id)}" v-text="teacher.Name" @click="previewTeacherSchedule(teacher.Id,teacher.Name)"></label>
                            <!-- <label :class="{'el-form-item__label float-left':true,'cs-list-item':true,'isClicked':checkTeacherIsClicked(form.teacherId)}" v-text="form.teacherName" @click="previewTeacherSchedule(form.teacherId,form.teacherName)"></label> -->
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="3">
                            <strong><label class="el-form-item__label float-right">时间：</label></strong>
                        </el-col>
                        <el-col :span="20" class="cs-top-content">
                            <label v-text="this.dayOfWeekStr"></label>
                            (<label v-text="courseHours"></label>小时)
                            <el-select v-model="form.startTimeValue" @change="changeStartTime" size="small" placeholder="开始时间">
                            <el-option v-for="item in startTimeList" :key="item.value" :label="item.label" :value="item.value" :disabled="item.disabled">
                            </el-option>
                            </el-select>
                            <label>至</label>
                                <el-select v-model="form.endTimeValue" @change="changeEndTime" size="small" placeholder="结束时间">
                                <el-option v-for="item in endTimeList" :key="item.value" :label="item.label" :value="item.value" :disabled="item.disabled">
                                </el-option>
                            </el-select>
                            <el-button type="primary btnRecalculate" @click="getCourseList">重新计算</el-button>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="3">
                            <strong><label class="el-form-item__label float-right">添加至：</label></strong>
                        </el-col>
                        <el-col :span="10">
                             <label class="el-form-item__label float-left" v-text="form.selectedPlanName"></label>
                        </el-col>
                    </el-row>
                    <el-row class="grid-content">
                        <el-col>
                          <el-table v-if="displayCalendar" v-loading="loading" :data="speedupCourses" :cell-class-name="cellStyle" :header-row-class-name="'el-table-header'">
                              <el-table-column type="index" width="50">
                              </el-table-column>
                              <el-table-column prop="courseName" label="课程" min-width="20%">
                                  <template slot-scope="scope">
                                    <div> 
                                        {{getCourseName(scope.row)}}
                                    </div>
                                  </template>  
                              </el-table-column>
                              <el-table-column prop="teacherName" label="速成老师" min-width="20%">
                                  <template slot-scope="scope">
                                    <div> 
                                      <span :class="{'cs-list-item':true,'isClicked':checkTeacherIsClicked(scope.row.teacherId)}" @click="previewTeacherSchedule(scope.row.teacherId,scope.row.teacherName)">{{scope.row.teacherName}}</span>
                                    </div>
                                  </template>  
                              </el-table-column>
                              <el-table-column prop="studentCount" label="班级人数" min-width="10%">
                              </el-table-column>
                              <el-table-column prop="attendanceRate" label="出勤率" min-width="15%">
                                  <template slot-scope="scope">
                                  <div> 
                                      {{scope.row.attendanceRate}}&nbsp;&nbsp;({{scope.row.attendanceCount}}人)
                                  </div>
                                  </template>  
                              </el-table-column>
                              <el-table-column prop="absenteeismRate" label="缺勤率" min-width="15%">
                                  <template slot-scope="scope">
                                  <div :class="{'cs-blue':scope.row.absenteeismCount > 0}"> 
                                      {{scope.row.absenteeismRate}}&nbsp;&nbsp;({{scope.row.absenteeismCount}}人)
                                        <img src="../../assets/arrow.png" v-if="scope.row.absenteeismCount > 0" @click="showAbsenceStudent(scope.row)">
                                  </div>
                                  </template> 
                              </el-table-column>
                              <el-table-column label="选择" min-width="10%">
                                  <template slot-scope="scope">
                                  <div> 
                                      <el-checkbox v-model="scope.row.isSelected" @change="selectCourse"></el-checkbox>
                                  </div>
                                  </template>
                                  </el-table-column> 
                          </el-table> 
                        </el-col>
                    </el-row>
                    <el-row class="cs-footer">
                        <el-col>
                            <el-button :disabled="disabledSubmit" type="primary" @click="submit">确认添加</el-button>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
        </el-col>
        <el-col :span="6" class="cs-right-container"> 
            <el-row class="student-title-container">
                <el-col>
                    <span class="cs-title">缺勤学生详情</span>
                </el-col>
            </el-row>
            <el-row class="student-container">
                <el-col>
                    <div v-if="selectedCourse">
                      <span class="student-course-title">{{selectedCourse.courseName + '(' + selectedCourse.absenteeismCount+ '人)'}}</span>
                    </div>
                    <div v-if="selectedCourse">
                      <span :class="{'student-course-listItem':true, 'isClicked':checkIsClicked(index)}" v-for="(student, index) in selectedCourse.studentList" :key="student.Id" @click="showStudent(student.Id, index)">{{formatPhone(student.Phone)}}</span>
                    </div>
                </el-col>
            </el-row>
        </el-col>
    </el-row>
    <el-dialog title="在校课程时间表" :center="true" :close-on-click-modal="false" width="70%" :visible.sync="displayStudentCourse" top="5vh">
      <studentCourseReview :data="currentStudentData" @close="closeStudentCourse" v-on:dialogFormVisibleEvent="onDialogFormVisibleEvent"></studentCourseReview>
    </el-dialog> 
    <el-dialog title="老师课程时间表" :center="true" :close-on-click-modal="false" width="70%" :visible.sync="displayTeacherCourse" top="5vh">
      <teacherCourseReview :data="teacherCourseData" @close="closeTeacherCourse" v-on:dialogFormVisibleEvent="onTeacherDialogVisibleEvent"></teacherCourseReview>
    </el-dialog> 
  </div>
</template>


<style lang="scss" scoped>
.addCourse-container {
  display: table;
  width: 100%;
  height: 100%;

  .cs-list-item{
    cursor: pointer;
    color: #3388c2;

    &:hover {
      opacity: 0.9;
    }
  }

  .cs-right-container {
    display: table-cell;
    padding-top: 100px;
    height: 100%;

    .student-title-container {
      padding: 40px 40px 0 40px;
      height: 100px;
      margin-top: -100px;
    }
    .student-container {
      padding: 0 40px 0 30px;
      background-color: whitesmoke;
      height: 100%;

      .student-course-title {
        display: block;
        color: black;
        margin-top: 10px;
        margin-bottom: 10px;
      }
      .student-course-listItem {
        display: block;
        color: #006ab3;
        margin-bottom: 5px;
        cursor: pointer;
      }
    }
  }
  .cs-left-container {
    display: table-cell;
    padding: 40px;
  }
  .cs-title {
    display: block;
    margin-bottom: 15px;
  }
  .grid-content {
    margin-top: 5px;
    .cs-schedule-buttonContainer {
      text-align: right;
    }
  }
  .right-area {
    padding-left: 50px;
  }
  label {
    line-height: 30px;
  }
  button {
    &.el-button--text {
      color: black;
      font-size: 15px;
    }
  }
  .cs-top-content {
    .el-select {
      margin: 0 10px;
      max-width: 160px;
    }
    .btnRecalculate{
      padding: 8px 20px;
    }
  }
  .cs-footer {
    margin-top: 15px;
  }

  .cs-blue {
    color: #006ab3;
    img {
      cursor: pointer;
    }
  }
}
</style>

<script>
import studentCourseReview from "../studentCourseReview";
import teacherCourseReview from "../teacherCourseReview";
import { formatTimeToInt60, formatTimeFromInt60, formatPhone } from "../../config/mUtils";
import { srcTimesOfDay, srcDaysOfWeek } from "../../service/api-base.service";
import {
  getAvailableCourse,
  saveSpeedupCourse
} from "../../service/speedupCourse.service";
import {
  getCourseTeacherList
} from "../../service/teacherCourse.service";


export default {
  data() {
    return {
      disabledSubmit:false,
      displayCalendar: true,
      displayStudentCourse: false,
      currentStudentData: {},
      displayTeacherCourse:false,
      teacherCourseData:{},
      courseSpan: 180,
      loading: false,
      daysOfWeekList: srcDaysOfWeek(),
      timesOfDay: [],
      minStartTime: "",
      maxEndTime: "",
      totalCourseCount: 30,
      startTimeList: [],
      endTimeList: [],
      selectedCourse: "",
      clickedStudentList: [],
      clickedTeacherList:[],
      courseHours:0,
      termId:0,
      form: {
        courseId: 0,
        courseClass: 0,
        courseName: "",
        teacherId: 0,
        teacherName: "",
        studentCount: 0,
        courseMinutes: 180,
        dayOfWeek: 0,
        startTimeValue: "",
        endTimeValue: "",
        selectedPlanId: 0,
        selectedPlanName: "",
        percentageText: "",
        plan:{},
      },
      speedupCourses: [],
      teacherList:[]
    };
  },
  props: {
    courseData: {},
    options:{
      start: Number,
      end: Number
    }
  },
  components: {
    studentCourseReview,
    teacherCourseReview
  },
  created() {
    this.timesOfDay = srcTimesOfDay(false, this.options.start, this.options.end);

    this.initData();
  },
  computed: {
    dayOfWeekStr() {
      if (this.form.dayOfWeek <= 0) {
        return "";
      }
      if (!!this.daysOfWeekList[this.form.dayOfWeek - 1]) {
        return this.daysOfWeekList[this.form.dayOfWeek - 1].label;
      }
      return "";
    }
  },
  methods: {
    formatPhone(phone){
      if (!this.USERMANAGER.isAdmin){
        return formatPhone(phone);
      }
      return phone;
    },
    closeStudentCourse() {
      this.displayStudentCourse = false;
    },
    onDialogFormVisibleEvent(visible) {
      this.displayStudentCourse = visible;
    },
    closeTeacherCourse() {
      this.displayTeacherCourse = false;
    },
    onTeacherDialogVisibleEvent(visible) {
      this.displayTeacherCourse = visible;
    },
    showStudent(id, index) {
      this.currentStudentData = {
        studentId: id,
        planId: this.form.selectedPlanId
      };
      this.displayStudentCourse = true;

      let list = [];
      this.clickedStudentList.forEach(element => {
        list.push(element);
      });
      list[index] = true;
      this.clickedStudentList = list;
    },
    getCourseName(item) {
      if (!item.courseClass) {
        return item.courseName;
      } else {
        return item.courseName + "-分班" + item.courseClass;
      }
    },
    checkIsClicked(index) {
      return this.clickedStudentList[index];
    },
    previewTeacherSchedule(teacherId, teacherName){
      let previewData = {
        teacherId:teacherId, 
        teacherName:teacherName,
        plan: this.form.plan
        };

      this.teacherCourseData = previewData;
      this.displayTeacherCourse = true;
      if (this.clickedTeacherList.indexOf(teacherId) < 0){
        this.clickedTeacherList.push(teacherId);
      }
    },
    checkTeacherIsClicked(id) {
      if (this.clickedTeacherList.indexOf(id) >= 0){
        return true;
      }
      return false;
    },
    showAbsenceStudent(row) {
      this.selectedCourse = row;

      this.clickedStudentList = [];
      if (this.selectedCourse.studentList) {
        this.selectedCourse.studentList.forEach(element => {
          this.clickedStudentList.push(false);
        });
      }
    },
    submit() {
      if (!this.validateTime()){
        return;
      }

      this.disabledSubmit = true;
      
      this.loading = true;
      let selectedList = [];
      if (this.displayCalendar && !!this.speedupCourses) {
        selectedList = this.speedupCourses.filter(i => i.isSelected);
      }

      let courseWithTeacher = [];
      courseWithTeacher.push({
        courseId: this.form.courseId,
        teacherId: this.form.teacherId,
        courseClass: this.form.courseClass
      });
      selectedList.forEach(i => {
        courseWithTeacher.push({
          courseId: i.courseId,
          teacherId: i.teacherId,
          courseClass: i.courseClass
        });
      });
      let startTime = formatTimeFromInt60(this.form.startTimeValue);
      let endTime = formatTimeFromInt60(this.form.endTimeValue);
      let self = this;
      saveSpeedupCourse(
        this.form.selectedPlanId,
        courseWithTeacher,
        this.form.dayOfWeek,
        startTime,
        endTime
      ).then(result => {
        if (result.success) {
          this.$message({
            message: "保存成功！",
            type: "success",
            onClose: function() {
              self.$emit("close", true);
            }
          });
        } else {
          if (result.message) {
            this.$message({
              message: result.message,
              type: "warning"
            });
          }
        }
        this.disabledSubmit = false;
        this.loading = false;
      });
    },
    selectCourse() {
      this.getCourseList(false);
    },
    changeStartTime() {

      this.displayCalendar = false;
      this.getTotalHours();
    },
    changeEndTime() {
  
       this.displayCalendar = false;
       this.getTotalHours();
    },
    validateTime(){
      if (!this.form.startTimeValue || !this.form.endTimeValue){
        return false;
      }

      let totalTime = this.form.endTimeValue - this.form.startTimeValue;
      if (totalTime <= 0){
        this.$message({
              message: "结束时间必须大于开始时间",
              type: "warning"
            });
        return false;
      }
  
      return true;
    },
    getTotalHours(){
      let totalTime = this.form.endTimeValue - this.form.startTimeValue;
      if (totalTime >0){
        this.courseHours = totalTime / 60;
      }else{
        this.courseHours = 0;
      }

    },
    getCourseList(clearAll = true) {
      if (!this.validateTime()){
        return;
      }
      this.clickedTeacherList = [];
      this.loading = true;
      let selectedList = [];
      if (!clearAll) {
        if (!!this.speedupCourses) {
          selectedList = this.speedupCourses.filter(i => i.isSelected);
        }
      }

      let courseWithTeacher = [];
      courseWithTeacher.push({
        courseId: this.form.courseId,
        teacherId: this.form.teacherId,
        courseClass: this.form.courseClass
      });
      selectedList.forEach(i => {
        courseWithTeacher.push({
          courseId: i.courseId,
          teacherId: i.teacherId,
          courseClass: i.courseClass
        });
      });

      let startTime = formatTimeFromInt60(this.form.startTimeValue);
      let endTime = formatTimeFromInt60(this.form.endTimeValue);
      getAvailableCourse(
        this.termId,
        this.form.selectedPlanId,
        courseWithTeacher,
        this.form.dayOfWeek,
        startTime,
        endTime
      ).then(result => {
        if (result.success) {
          if (result.data) {
            result.data.forEach(i => {
              let attendanceCount = i.TotalCount - i.UnavailableCount;
              let attendanceRate = Math.round(
                attendanceCount * 100 / i.TotalCount
              );
              let absenteeismRate = 100 - attendanceRate;
              let item = {
                courseId: i.CourseId,
                courseName: i.CourseName,
                teacherId: i.TeacherId,
                teacherName: i.TeacherName,
                courseClass: i.CourseClass,
                studentCount: i.TotalCount.toString() + "人",
                attendanceRate: attendanceRate.toString() + "%",
                attendanceCount: attendanceCount,
                absenteeismRate: absenteeismRate.toString() + "%",
                absenteeismCount: i.UnavailableCount,
                studentList: i.StudentList,
                isSelected: false
              };
              if (selectedList.length < this.totalCourseCount) {
                selectedList.push(item);
              } else {
                return;
              }
            });
            this.speedupCourses = selectedList;
          }
        } else {
          if (result.message) {
            this.$message({
              message: result.message,
              type: "warning"
            });
          }
        }
        this.loading = false;
        this.displayCalendar = true;
      });
    },
    cellStyle(cell) {
      if ((cell.rowIndex + 1) % 2 == 1) {
        return "el-table-cell-single";
      } else return "el-table-cell-double";
    },
    back() {
      //this.$router.push("/admin/speedupCourseSchedule");
      this.$emit("close", false);
    },
    resetStartEndTime() {
      if (this.minStartTime && this.maxEndTime) {
        let minStartTime60 = formatTimeToInt60(this.minStartTime);
        let maxEndTime60 = formatTimeToInt60(this.maxEndTime, true);
        let startList = [];
        let endList = [];

        this.timesOfDay.forEach((item, index) => {
          if (
            item.value >= minStartTime60 &&
            item.value <= maxEndTime60 //- this.courseSpan
          ) {
            startList.push(item);
          }
          if (
            item.value >= minStartTime60 //+ this.courseSpan 
            && item.value <= maxEndTime60
          ) {
            endList.push(item);
          }
        });
        this.startTimeList = startList;
        this.endTimeList = endList;

        this.form.startTimeValue = minStartTime60;
        this.form.endTimeValue = minStartTime60 + this.courseSpan;
        this.getTotalHours();
      }
    },
    getTeacherList(){
      this.teacherList = [];
      if (!!this.courseData.courseId){
        getCourseTeacherList(this.courseData.courseId, this.courseData.campusId).then(result=>{
          if (!!result && result.success){
            this.teacherList = result.data;
          }
        });
      }
    },
    initData() {
      if (!!this.courseData) {
        this.courseSpan = this.courseData.courseMinutes;
        if (!this.courseSpan){
          this.courseSpan = 180;
        }

        this.termId = this.courseData.termId;
        this.minStartTime = this.courseData.startTime;
        this.maxEndTime = this.courseData.endTime;
        this.form.courseId = this.courseData.courseId;
        this.form.courseClass = this.courseData.courseClass;
        this.form.courseName = this.courseData.courseName;
        this.form.teacherId = this.courseData.teacherId;
        this.form.teacherName = this.courseData.teacherName;
        this.form.studentCount = this.courseData.studentCount;
        this.form.dayOfWeek = this.courseData.dayOfWeek;
        this.form.selectedPlanId = this.courseData.planId;
        this.form.selectedPlanName = this.courseData.planName;
        this.form.percentageText = this.courseData.percentageText;
        this.form.plan = this.courseData.plan;
     

        this.resetStartEndTime();
        this.getTeacherList();
        this.getCourseList();
        
        this.disabledSubmit = false;
      }
    }
  },
  watch: {
    courseData: function() {
      this.initData();
    }
  }
};
</script>
 



// WEBPACK FOOTER //
// src/components/speedupCourse/addCourseToPlan.vue